import Axios from 'axios';

export interface SearchResultItem {

}

export interface SearchResult {
	results: SearchResultItem[] | any[]; // TODO: Remove any
	buckets: any;
	meta: SearchMetaData;
}

export interface SearchMetaData {
	hits: number;
	pages: number;
	time: number;
}
export interface GeoProps{
    lat?: number;
    lng?: number;
    distance?: number
}


export default class SearchService {

	private seed: number;

	constructor(private endpoint: string) {
		this.seed = Math.floor(Math.random() * 100);
	}

	public setId(id: number) {
		this.seed = id;
	}

	public search(withGeo: boolean, filters: Map<string, Set<string>>, limit: number = 15, offset: number = 0, geo: GeoProps): Promise<SearchResult> {
		const axios = Axios.create({});

		const filterBody: any = {};
		filters.forEach((values, filterName) => {
			filterBody[filterName] = Array.from(values);
		});

        const getGeo = withGeo ? "1" : "0";

		let searchBody = {
			"filters": filterBody,
            ...(geo.lat !== undefined && geo.lng !== undefined && {"geo": geo})
		}

		return axios.post(this.endpoint + '/search?id=' + this.seed + '&offset=' + offset + '&limit=' + limit  + '&withGeo=' +getGeo, searchBody)
            .then(response => response.data)
            .catch((err) => err);
	}

	public suggest(query: string) {
		const axios = Axios.create({});

		return axios.post(this.endpoint + '/suggest', {query}).then(response => response.data);
	}
}
